import React, { useState, useEffect } from "react";
import { Ellipsis } from "antd-mobile";
import _ from "underscore";

import authStore from "../../stores/authStore";
import homeStore from "../../stores/homeStore";
import platformIcon from "../../assets/images/platform-icon.png";
import editIcon from "../../assets/images/edit-icon.png";
import closeEyeIcon from "../../assets/images/close-eye-icon.png";
import eyeIcon from "../../assets/images/eye-icon.png";
import deleteIcon from "../../assets/images/delete-icon.png";
import AddCaseDialog from "./AddCaseDialog";
import SuccessDialog from "./SuccessDialog";
import EditInfoDialog from "./EditInfoDialog";
import SureDeleteDialog from "./SureDeleteDialog";

import { Pager, Header, Body, Footer } from "../../layout/index";
import {
  Nav,
  Icon,
  Loading,
  HoverCard,
  HoverList,
} from "../../components/index";
import { isMobile } from "../../utils/tools";

import "./style.scss";

const Home = () => {
  const { userInfo } = authStore();
  const {
    homeList,
    homeLoading,
    homePagination,
    fetchHomeList,
    setReplaceList,
    fetchEvaluate,
    handleEvaluate,
    addCase,
    setAddCase,
    successShow,
    setSuccessShow,
    editInfo,
    setEditInfo,
    handleInfo,
    fetchDisabled,
    sureDelete,
    setSureDelete,
    fetchDelete,
    fetchViewsCount,
  } = homeStore();
  const [deleteId, fetchDeleteId] = useState("");
  const [caseInfo, setCaseInfo] = useState({});
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const onScrollEvent = _.debounce(async () => {
    if (!homeLoading && homePagination.hasNextPage) {
      const dom: any = document.querySelector(".home");
      if (dom.scrollTop + dom.clientHeight > dom.scrollHeight * 0.9) {
        await fetchHomeList(true);
        if (!homeLoading && !userInfo.id) {
          setReplaceList();
        }
      }
    }
  }, 300);

  useEffect(() => {
    fetchHomeList();
  }, []);

  useEffect(() => {
    if (!homeLoading && !userInfo.id) {
      setReplaceList();
    }
  }, [userInfo.id, homeLoading]);

  return (
    <Pager>
      <Header>
        <Nav />
      </Header>
      <Body>
        <div className="home" onScrollCapture={onScrollEvent}>
          <div className="home-content">
            {(userInfo.manager || userInfo.invited) && (
              <img
                className="home__add"
                src={window._config.assets.add}
                alt="add"
                onClick={() => setAddCase(true)}
              />
            )}
            {homeList && homeList.length > 0 && (
              <HoverList className="home__list" hoverBg="#f8f8fa">
                {homeList.map(
                  (item: any, index: number) =>
                    // 隐藏case仅有管理权限可见(opacity:0.5)
                    // 标题和描述任意缺一仅有管理权限可见
                    // status: finished 标题和内容完成生成
                    item.status === "finished" &&
                    !(
                      (item.disabled || !item.title || !item.summary) &&
                      !(userInfo.manager || item.isAuthor)
                    ) && (
                      //     <div
                      //       className="home__item--wrapper"
                      //       key={item.id}
                      //       onClick={() => {
                      //         if (item.originalLink) {
                      //           fetchViewsCount(item.id);
                      //           window.openNew(item.originalLink);
                      //         }
                      //       }}
                      //     >
                      //       <div
                      //         className={`home__item ${item.disabled && (userInfo.manager || item.isAuthor) && "home__item--hide"}`}
                      //       >
                      //         {item.title && item.summary ? (
                      //           <>
                      //             <p className="home__item-title">{item.title}</p>
                      //             <Ellipsis
                      //               className="home__item-content"
                      //               direction="end"
                      //               rows={2}
                      //               content={item.summary}
                      //               expandText={
                      //                 <>
                      //                   展开
                      //                   <Icon
                      //                     name="expand-icon"
                      //                     size="14"
                      //                     color={
                      //                       window._config.style["primary-color"]
                      //                     }
                      //                   />
                      //                 </>
                      //               }
                      //               collapseText={
                      //                 <>
                      //                   收起
                      //                   <Icon
                      //                     name="collapse-icon"
                      //                     size="14"
                      //                     color={
                      //                       window._config.style["primary-color"]
                      //                     }
                      //                   />
                      //                 </>
                      //               }
                      //               stopPropagationForActionButtons={["click"]} // 阻止展开/收起按钮的事件冒泡
                      //             />
                      //           </>
                      //         ) : (
                      //           <div
                      //             className="home__item-nothing"
                      //             onClick={(e) => {
                      //               e.stopPropagation();
                      //               e.preventDefault();
                      //             }}
                      //           >
                      //             {isMobile()
                      //               ? "AI生成失败，请前往桌面端人工补齐数据或重新添加。"
                      //               : "AI 生成失败，请人工补齐数据或重新添加。"}
                      //             <span>源链接：{item.originalLink}</span>
                      //           </div>
                      //         )}
                      //         <div className="home__item-bottom">
                      //           <div className="home__item-left">
                      //             {item.user && (
                      //               <>
                      //                 由
                      //                 <div className="home__item-avatar">
                      //                   <img
                      //                     src={item.user.avatarUrl}
                      //                     alt="avatar"
                      //                   />
                      //                 </div>
                      //                 <span className="home__item-name">
                      //                   {item.user.name || item.user.commonName}
                      //                 </span>
                      //                 推荐
                      //               </>
                      //             )}
                      //             {item.domainName && (
                      //               <>
                      //                 <i></i>
                      //                 <img src={platformIcon} alt="platform" />
                      //                 来源
                      //                 <span className="home__item-platform">
                      //                   {item.domainName}
                      //                 </span>
                      //               </>
                      //             )}
                      //             {!isMobile() && item.updatedTime && (
                      //               <>
                      //                 <i></i>
                      //                 {item.updatedTime}
                      //               </>
                      //             )}
                      //           </div>
                      //           <div className="home__item-right--wrapper">
                      //             {isMobile() && item.updatedTime && (
                      //               <div className="home__item-time">
                      //                 {item.updatedTime}
                      //               </div>
                      //             )}
                      //             <div className="home__item-right">
                      //               {/* 为实现渐变边框效果，多包一层 */}
                      //               <div
                      //                 className={`home__evaluate ${item.evaluate.hasHaokan && "home__evaluate--active"}`}
                      //                 onClick={async (e) => {
                      //                   e.stopPropagation();
                      //                   e.preventDefault();
                      //                   if (userInfo.id) {
                      //                     // 已登录
                      //                     fetchEvaluate(item.id, "haokan");
                      //                   } else {
                      //                     // 未登录，手动修改本地状态
                      //                     handleEvaluate(
                      //                       item.id,
                      //                       "hasHaokan",
                      //                       "haokansCount"
                      //                     );
                      //                   }
                      //                 }}
                      //               >
                      //                 <div>
                      //                   <img
                      //                     src={window._config.assets.good}
                      //                     alt="haokan"
                      //                   />
                      //                   {window._config.text.haobtn}
                      //                   {!!item.evaluate &&
                      //                     !!item.evaluate.haokansCount && (
                      //                       <p>+{item.evaluate.haokansCount}</p>
                      //                     )}
                      //                 </div>
                      //               </div>
                      //               <div
                      //                 className={`home__evaluate ${item.evaluate.hasGuanwang && "home__evaluate--active"}`}
                      //                 onClick={async (
                      //                   e: React.BaseSyntheticEvent
                      //                 ) => {
                      //                   e.stopPropagation();
                      //                   e.preventDefault();
                      //                   if (userInfo.id) {
                      //                     // 已登录
                      //                     fetchEvaluate(item.id, "guanwang");
                      //                   } else {
                      //                     // 未登录，手动修改本地状态
                      //                     handleEvaluate(
                      //                       item.id,
                      //                       "hasGuanwang",
                      //                       "guanwangsCount"
                      //                     );
                      //                   }
                      //                 }}
                      //               >
                      //                 <div>
                      //                   <img
                      //                     src={window._config.assets.look}
                      //                     alt="guanwang"
                      //                   />
                      //                   {window._config.text.badbtn}
                      //                   {!!item.evaluate &&
                      //                     !!item.evaluate.guanwangsCount && (
                      //                       <p>+{item.evaluate.guanwangsCount}</p>
                      //                     )}
                      //                 </div>
                      //               </div>
                      //             </div>
                      //           </div>
                      //         </div>
                      //         {/* PC端显示 && 角色权限：
                      //     管理员
                      //     受邀用户：受邀用户只能在前台管理自己发布的内容(即作者)
                      // */}
                      //         {!isMobile() &&
                      //           (userInfo.manager || item.isAuthor) && (
                      //             <div
                      //               className="home__item-manage"
                      //               onClick={(e: React.BaseSyntheticEvent) => {
                      //                 e.stopPropagation();
                      //                 e.preventDefault();
                      //               }}
                      //             >
                      //               <div className="home__item-btns">
                      //                 <div
                      //                   onClick={() => {
                      //                     setCaseInfo(item);
                      //                     setEditInfo(true);
                      //                   }}
                      //                 >
                      //                   <img src={editIcon} alt="edit" />
                      //                   编辑
                      //                 </div>
                      //                 <div
                      //                   onClick={async () =>
                      //                     fetchDisabled(item.id, item.disabled)
                      //                   }
                      //                 >
                      //                   <img
                      //                     src={
                      //                       item.disabled ? eyeIcon : closeEyeIcon
                      //                     }
                      //                     alt="hide"
                      //                   />
                      //                   {item.disabled ? "取消隐藏" : "隐藏"}
                      //                 </div>
                      //                 <div
                      //                   onClick={() => {
                      //                     fetchDeleteId(item.id);
                      //                     setSureDelete(true);
                      //                   }}
                      //                 >
                      //                   <img src={deleteIcon} alt="delete" />
                      //                   删除
                      //                 </div>
                      //               </div>
                      //               <div className="home__item-count">
                      //                 统计：{item.userViewsCount} 人点击过
                      //               </div>
                      //             </div>
                      //           )}
                      //       </div>
                      //     </div>
                      <HoverCard
                        key={item.id}
                        className="home__item--wrapper"
                        hoveredIndex={hoveredIndex}
                        index={index}
                        initTop={8}
                      >
                        <div
                          className={`home__item ${item.disabled && (userInfo.manager || item.isAuthor) && "home__item--hide"}`}
                          onClick={() => {
                            if (item.originalLink) {
                              fetchViewsCount(item.id);
                              window.openNew(item.originalLink);
                            }
                          }}
                          onMouseEnter={() => setHoveredIndex(index)}
                          onMouseLeave={() => setHoveredIndex(null)}
                        >
                          {item.title && item.summary ? (
                            <>
                              <p className="home__item-title">{item.title}</p>
                              <Ellipsis
                                className="home__item-content"
                                direction="end"
                                rows={2}
                                content={item.summary}
                                expandText={
                                  <>
                                    展开
                                    <Icon
                                      name="expand-icon"
                                      size="14"
                                      color={
                                        window._config.style["primary-color"]
                                      }
                                    />
                                  </>
                                }
                                collapseText={
                                  <>
                                    收起
                                    <Icon
                                      name="collapse-icon"
                                      size="14"
                                      color={
                                        window._config.style["primary-color"]
                                      }
                                    />
                                  </>
                                }
                                stopPropagationForActionButtons={["click"]} // 阻止展开/收起按钮的事件冒泡
                              />
                            </>
                          ) : (
                            <div
                              className="home__item-nothing"
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                              }}
                            >
                              {isMobile()
                                ? "AI生成失败，请前往桌面端人工补齐数据或重新添加。"
                                : "AI 生成失败，请人工补齐数据或重新添加。"}
                              <span>源链接：{item.originalLink}</span>
                            </div>
                          )}
                          <div className="home__item-bottom">
                            <div className="home__item-left">
                              {item.user && (
                                <>
                                  由
                                  <div className="home__item-avatar">
                                    <img
                                      src={item.user.avatarUrl}
                                      alt="avatar"
                                    />
                                  </div>
                                  <span className="home__item-name">
                                    {item.user.name || item.user.commonName}
                                  </span>
                                  推荐
                                </>
                              )}
                              {item.domainName && (
                                <>
                                  <i></i>
                                  <img src={platformIcon} alt="platform" />
                                  来源
                                  <span className="home__item-platform">
                                    {item.domainName}
                                  </span>
                                </>
                              )}
                              {!isMobile() && item.updatedTime && (
                                <>
                                  <i></i>
                                  {item.updatedTime}
                                </>
                              )}
                            </div>
                            <div className="home__item-right--wrapper">
                              {isMobile() && item.updatedTime && (
                                <div className="home__item-time">
                                  {item.updatedTime}
                                </div>
                              )}
                              <div className="home__item-right">
                                {/* 为实现渐变边框效果，多包一层 */}
                                <div
                                  className={`home__evaluate ${item.evaluate.hasHaokan && "home__evaluate--active"}`}
                                  onClick={async (e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    if (userInfo.id) {
                                      // 已登录
                                      fetchEvaluate(item.id, "haokan");
                                    } else {
                                      // 未登录，手动修改本地状态
                                      handleEvaluate(
                                        item.id,
                                        "hasHaokan",
                                        "haokansCount"
                                      );
                                    }
                                  }}
                                >
                                  <div>
                                    <img
                                      src={window._config.assets.good}
                                      alt="haokan"
                                    />
                                    {window._config.text.haobtn}
                                    {!!item.evaluate &&
                                      !!item.evaluate.haokansCount && (
                                        <p>+{item.evaluate.haokansCount}</p>
                                      )}
                                  </div>
                                </div>
                                <div
                                  className={`home__evaluate ${item.evaluate.hasGuanwang && "home__evaluate--active"}`}
                                  onClick={async (
                                    e: React.BaseSyntheticEvent
                                  ) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    if (userInfo.id) {
                                      // 已登录
                                      fetchEvaluate(item.id, "guanwang");
                                    } else {
                                      // 未登录，手动修改本地状态
                                      handleEvaluate(
                                        item.id,
                                        "hasGuanwang",
                                        "guanwangsCount"
                                      );
                                    }
                                  }}
                                >
                                  <div>
                                    <img
                                      src={window._config.assets.look}
                                      alt="guanwang"
                                    />
                                    {window._config.text.badbtn}
                                    {!!item.evaluate &&
                                      !!item.evaluate.guanwangsCount && (
                                        <p>+{item.evaluate.guanwangsCount}</p>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* PC端显示 && 角色权限：
                      管理员
                      受邀用户：受邀用户只能在前台管理自己发布的内容(即作者)
                  */}
                          {!isMobile() &&
                            (userInfo.manager || item.isAuthor) && (
                              <div
                                className="home__item-manage"
                                onClick={(e: React.BaseSyntheticEvent) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                }}
                              >
                                <div className="home__item-btns">
                                  <div
                                    onClick={() => {
                                      setCaseInfo(item);
                                      setEditInfo(true);
                                    }}
                                  >
                                    <img src={editIcon} alt="edit" />
                                    编辑
                                  </div>
                                  <div
                                    onClick={async () =>
                                      fetchDisabled(item.id, item.disabled)
                                    }
                                  >
                                    <img
                                      src={
                                        item.disabled ? eyeIcon : closeEyeIcon
                                      }
                                      alt="hide"
                                    />
                                    {item.disabled ? "取消隐藏" : "隐藏"}
                                  </div>
                                  <div
                                    onClick={() => {
                                      fetchDeleteId(item.id);
                                      setSureDelete(true);
                                    }}
                                  >
                                    <img src={deleteIcon} alt="delete" />
                                    删除
                                  </div>
                                </div>
                                <div className="home__item-count">
                                  统计：{item.userViewsCount} 人点击过
                                </div>
                              </div>
                            )}
                        </div>
                      </HoverCard>
                    )
                )}
                <Loading
                  style={{ height: "96px" }}
                  page={homePagination.page}
                  hasNextPage={homePagination.hasNextPage}
                  loading={homeLoading}
                  moreDom={
                    <div
                      className="load-more--normal"
                      onClick={() => {
                        fetchHomeList(true);
                        if (!homeLoading && !userInfo.id) {
                          setReplaceList();
                        }
                      }}
                    >
                      加载更多
                    </div>
                  }
                />
              </HoverList>
            )}
          </div>
          <Footer />
        </div>
        <AddCaseDialog
          visible={addCase}
          onSuccess={() => {
            setSuccessShow(true);
            fetchHomeList(!!userInfo.id);
          }}
        />
        <SuccessDialog visible={successShow} />
        {editInfo && (
          <EditInfoDialog
            visible={editInfo}
            info={caseInfo}
            onSuccess={(values) => handleInfo(values)}
          />
        )}
        <SureDeleteDialog
          id={deleteId}
          visible={sureDelete}
          onClose={() => fetchDeleteId("")}
          onSuccess={() => fetchDelete(deleteId)}
        />
      </Body>
    </Pager>
  );
};

export default Home;
